import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router'


@Component({
  selector: 'app-slideshow',
  templateUrl: './slideshow.component.html',
  styleUrls: ['./slideshow.component.css'],
 
})





export class SlideshowComponent implements OnInit {


   
  
  ngOnInit(): void {

        

  }

}
